window.addEventListener("DOMContentLoaded", (event) => {
  $(document).ready(function () {
    if ($(window).width() > 1023) {
      var d = {};
      $product = $(".product-template");
      (d.$productGallery = $product.find(".product__media-wrapper")),
        (d.$productGalleryItem = $product.find(
          ".main_product_slider .product__media-item:not(.hide)"
        )),
        (d.$productCarousel = d.$productGallery.children(
          ".main_product_slider"
        )),
        (d.$productGalleryNavigation = $product.find(".thumbnails_slider")),
        (d.$productGalleryNavigationItem = $product.find(
          ".thumbnails_slider .product__media-item:not(.hide)"
        ));

      $(window)
        .on(
          "scroll.main_product_slider",
          function () {
            $(".main_product_slider .product__media-item").each(
              function (t, e) {
                if (
                  $(window).scrollTop() + $(window).height() + 500 >
                    $(e).offset().top + $(window).height() &&
                  !$(e).hasClass("active")
                ) {
                  $(e).addClass("active"),
                    $(".thumbnails_slider .product__media-item").removeClass(
                      "active"
                    ),
                    $(".thumbnails_slider .product__media-item")
                      .eq($(e).index())
                      .addClass("active");
                } else {
                  $(window).scrollTop() + $(window).height() + 500 <
                    $(e).offset().top + $(window).height() &&
                    $(e).hasClass("active") &&
                    ($(e).removeClass("active"),
                    $(".thumbnails_slider .product__media-item").removeClass(
                      "active"
                    ),
                    $(".thumbnails_slider .product__media-item")
                      .eq($(e).index() - 1)
                      .addClass("active")),
                    $(window).scrollTop() + $(window).height() >
                      $(".product__media-wrapper").height() &&
                    !$(".thumbnails_slider").hasClass("scroll") &
                      ($(".thumbnails_slider").find(".thumb--item").length > 1)
                      ? $(".thumbnails_slider").addClass("scroll")
                      : $(window).scrollTop() + $(window).height() <
                          $(".product__media-wrapper").height() &&
                        $(".thumbnails_slider").hasClass("scroll") &&
                        $(".thumbnails_slider").removeClass("scroll");
                }
              }.bind(d)
            );
          }.bind(d)
        )
        .trigger("scroll.product-gallery");

      $(document).on(
        "click",
        ".thumbnails_slider .product__media-item",
        function (evt) {
          evt.preventDefault();
          $(".thumbnails_slider").addClass("clicking");
          var activeThumbnail = $(evt.target).closest(
            ".thumbnails_slider .product__media-item"
          );
          $(".thumbnails_slider .product__media-item").each(function (t, e) {
            $(e).removeClass("active");
            $(".main_product_slider .product__media-item")
              .eq($(activeThumbnail).index())
              .addClass("active");
          });
          $("html, body").animate(
            {
              scrollTop:
                $(".main_product_slider .product__media-item")
                  .eq($(activeThumbnail).index())
                  .offset().top - 100,
            },
            100
          );

          console.log(activeThumbnail);
          $(activeThumbnail).addClass("active");
          setTimeout(() => {
            $(".thumbnails_slider").removeClass("clicking");
          }, 1000);
        }
      );
    } else {
      $(".main_product_slider").slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: false,
        slide: ".carousel--item:not(.hide)",
      });
    }

    var CaseOption = $("#alternate_product .swatch").length;

    $(document).on(
      "change",
      "#alternate_product .swatch input[type='radio']",
      function () {
        var value = $(this).val();
        $('.swatch-element input[value="' + value + '"]').prop("checked", true);
        if (CaseOption === 3) {
          thirdAvailability(true);
        } else if (CaseOption == 2) {
          secondAvailability(true);
        } else if (CaseOption == 1) {
          oneAvailability(true);
        }
      }
    );

    $(".alternate_product_page_section .sezzel-at-checkout h4").on(
      "click",
      function (e) {
        e.preventDefault();
        $(
          ".alternate_product_page_section .sezzel-at-checkout .sezzel-at-checkout-inner"
        ).addClass("active");
      }
    );

    var gallery_height = $(window).height() - 120;
    var info_height = $(".product__info-container--sticky").height();

    if (info_height > gallery_height) {
      $(".product__info-wrapper").addClass("enable_sticky");
    }

    $(
      ".product .product__info-wrapper .product__info-container .accordion input[type=checkbox]"
    ).change(function () {
      info_height = $(".product__info-container--sticky").height();
      if (info_height > gallery_height) {
        $(".product__info-wrapper").addClass("enable_sticky");
      } else {
        $(".product__info-wrapper").removeClass("enable_sticky");
      }
    });

    $('a[href="#quizpopup"]').on("click", function (e) {
      e.preventDefault();
      $("button[data-tf-popup]").trigger("click");
    });
    if (CaseOption == 3) {
      thirdAvailability(false);
    }
    if (CaseOption == 2) {
      secondAvailability(false);
    }
    if (CaseOption == 1) {
      oneAvailability(false);
    }
    if (CaseOption == 0) {
      defaultAvailability(false);
    }
    $(".chat-link").on("click", function (e) {
      e.preventDefault();
      var id = $(this).attr("href");
      $(id).addClass("active");
    });
    $(".js-sizechart-lightbox .close").on("click", function (e) {
      e.preventDefault();
      $(this).parent().parent().parent().removeClass("active");
    });

    document.addEventListener("rebuy:cart.change", function (event) {
      const Cart = window.Rebuy.Cart;
      var variantPrice = $(".product-template .sezzel-at-checkout h4").attr(
        "data-price"
      );
      $(".product-template .sezzel-at-checkout h4").attr(
        "data-cart",
        Cart.subtotal()
      );
      var totalPrice = parseInt(Cart.subtotal()) + parseInt(variantPrice);
      if (totalPrice > 100000) {
        $(".product-template .sezzel-at-checkout h4").removeClass("active");
        $(".product-template .sezzel-at-checkout h4.over-1000").addClass(
          "active"
        );
        $(".sezzle-button-text img").attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2494/2652/files/affirm_x44.png?v=1669732943"
        );
        $(".sezzle-button-text img").addClass("affirm-logo");
        $(".sezzle-button-text img").addClass("active");
      } else {
        $(".product-template .sezzel-at-checkout h4").removeClass("active");
        $(".product-template .sezzel-at-checkout h4.under-1000").addClass(
          "active"
        );
        $(".sezzle-button-text img").attr(
          "src",
          "https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg"
        );
        $(".sezzle-button-text img").removeClass("affirm-logo");
        $(".sezzle-button-text img").addClass("active");
      }
    });
  });

  function defaultAvailability() {
    var pre_order_text = $("select.all-variants option:selected")
      .attr("pre-order-text")
      .trim();
    if (pre_order_text.toLowerCase().includes("pre-order")) {
      var pre_order_text1 = pre_order_text.split("(")[1];
      var pre_order_text2 = pre_order_text1.split(")")[0];
      $(".product-template .hush_product_button")
        .find("button:eq(0) > span")
        .html(pre_order_text2);
      $("#sticky-product-form .product-form__submit > span").html("pre-order");
      $(".pre-order_stock").addClass("active");
      $("#sticky-product-form .product-form__submit").addClass("pre_order_btn");
      $("#sticky-product-form .product-form__submit").removeClass(
        "buy_now_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass("sold_out");
      $(".product-template .btn_etxt_properties").val(pre_order_text2);
      $(".product-template .btn_etxt_propertie_shipping").val(pre_order_text2);
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .addClass("pre_order_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("buy_now_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("add_to_cat_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("sold_out");
    } else if (
      pre_order_text.includes("Buy Now") ||
      pre_order_text.includes("FAST AND FREE")
    ) {
      var pre_order_text1 = pre_order_text.split("(")[1];
      var pre_order_text2 = pre_order_text1.split(")")[0];
      $(".product-template .hush_product_button")
        .find("button:eq(0) > span")
        .html(pre_order_text2);
      $("#sticky-product-form .product-form__submit > span").html(
        "Add to cart"
      );
      $("#sticky-product-form .product-form__submit").addClass(
        "add_to_cat_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass(
        "pre_order_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass("sold_out");
      $(".product-template .btn_etxt_properties").val(pre_order_text2);
      $(".product-template .btn_etxt_propertie_shipping").val("");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .addClass("buy_now_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("pre_order_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("add_to_cat_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("sold_out");
    } else if (pre_order_text.includes("sold out")) {
      var pre_order_text1 = pre_order_text.split("(")[1];
      var pre_order_text2 = pre_order_text1.split(")")[0];
      $(".product-template .hush_product_button")
        .find("button:eq(0) > span")
        .html(pre_order_text2);
      $("#sticky-product-form .product-form__submit > span").html("Sold Out");
      $("#sticky-product-form .product-form__submit").addClass("sold_out");
      $("#sticky-product-form .product-form__submit").removeClass(
        "pre_order_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass(
        "add_to_cat_btn"
      );
      $(".product-template .btn_etxt_properties").val(pre_order_text2);
      $(".product-template .btn_etxt_propertie_shipping").val("");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .addClass("sold_out");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("buy_now_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("pre_order_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("add_to_cat_btn");
    } else {
      $(".product-template .hush_product_button")
        .find("button:eq(0) > span")
        .html("Buy Now - Fast & Free Shipping");
      $("#sticky-product-form .product-form__submit > span").html(
        "Add to cart"
      );
      $("#sticky-product-form .product-form__submit").addClass(
        "add_to_cat_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass(
        "pre_order_btn"
      );
      $("#sticky-product-form .product-form__submit").removeClass("sold_out");
      $(".product-template .btn_etxt_properties").val("Add to cart");
      $(".product-template .btn_etxt_propertie_shipping").val("");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .addClass("add_to_cat_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("pre_order_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("buy_now_btn");
      $(".product-template .hush_product_button")
        .find("button:eq(0)")
        .removeClass("sold_out");
    }
  }

  function oneAvailability(display_variants) {
    // alert('1')
    var option0 = $('.swatch-element input[name="option-0"]:checked')
      .val()
      .toLowerCase();
    if (option0 != "") {
      $('.swatch-element input[name="option-0"]').each(function () {
        var option0_val = $(this).val();
        var optionFlag = false;
        var soldoutFlag = false;
        console.log(option0_val);
        $("select.all-variants option").each(function () {
          var all_options = $(this).attr("data-name");
          // alert('ok'+all_options)
          if (all_options.includes(option0_val)) {
            optionFlag = true;
            if ($(this).attr("data-btntxt") == "jtpl-sold") {
              soldoutFlag = true;
            } else {
              soldoutFlag = false;
            }
          }
        });

        if (optionFlag == true) {
          $(this).closest(".swatch-element").addClass("available");
          $(this).closest(".swatch-element").addClass("available_0");
          $(this).closest(".swatch-element").removeClass("Unavailable_0");
          $(this).closest(".swatch-element").removeClass("soldout");
          if (soldoutFlag == true) {
            $(this).closest(".swatch-element").addClass("soldout");
          }
        } else {
          $(this).closest(".swatch-element").addClass("Unavailable_0");
          $(this).closest(".swatch-element").removeClass("available_0");
          $(this).closest(".swatch-element").removeClass("available");
        }
      });

      $('.swatch-element input[name="sticky-option-0"]').each(function () {
        var option0_val = $(this).val();
        var optionFlag = false;
        var soldoutFlag = false;
        $("select.all-variants option").each(function () {
          var all_options = $(this).attr("data-name");
          // alert('ok'+all_options)
          if (all_options.includes(option0_val)) {
            optionFlag = true;
            if ($(this).attr("data-btntxt") == "jtpl-sold") {
              soldoutFlag = true;
            } else {
              soldoutFlag = false;
            }
          }
        });

        if (optionFlag == true) {
          $(this).closest(".swatch-element").addClass("available");
          $(this).closest(".swatch-element").addClass("available_0");
          $(this).closest(".swatch-element").removeClass("Unavailable_0");
          $(this).closest(".swatch-element").removeClass("soldout");
          if (soldoutFlag == true) {
            $(this).closest(".swatch-element").addClass("soldout");
          }
        } else {
          $(this).closest(".swatch-element").addClass("Unavailable_0");
          $(this).closest(".swatch-element").removeClass("available_0");
          $(this).closest(".swatch-element").removeClass("available");
        }
      });

      $("select.all-variants option").each(function () {
        var data_name = $(this).attr("data-name").toLowerCase();

        if (data_name == option0) {
          var variant_id = $(this).val();
          var variant_price = Shopify.formatMoney(
            $(this).attr("varient_price")
          );
          var compaire_price = Shopify.formatMoney(
            $(this).attr("compare_price")
          );

          var variant_price_without_moneyformat = $(this).attr("varient_price");
          var compaire_price_without_moneyformat =
            $(this).attr("compare_price");

          $("select.all-variants option").removeAttr("selected");
          $(this).attr("selected", "selected");
          $("select.all-variants").val(variant_id).trigger("change");
          $(".product-template")
            .find("product-form form")
            .find('input[name="id"]')
            .each(function () {
              $(this).val(variant_id);
            });

          if (
            variant_price_without_moneyformat.length != 0 &&
            compaire_price_without_moneyformat.length == 0
          ) {
            $(".product-template .price.price--large").removeClass(
              "price--on-sale"
            );
            $(".product-template .price__regular dd span").html(
              variant_price.replace(".00", "")
            );
          } else if (
            variant_price_without_moneyformat.length != 0 &&
            compaire_price_without_moneyformat.length != 0
          ) {
            $(".product-template .price.price--large").addClass(
              "price--on-sale"
            );
            $(
              ".product-template .price.price--large.price--on-sale dd.price__compare s.price-item--regular"
            ).html(compaire_price.replace(".00", ""));
            $(".product-template")
              .find(".price.price--large.price--on-sale")
              .find("dd")
              .find("span.price-item.price-item--sale")
              .html(variant_price.replace(".00", ""));
          }

          $(".product-template .sezzel-at-checkout h4").attr(
            "data-price",
            variant_price_without_moneyformat
          );
          $(".product-template span.product_price_main.left-price").html(
            variant_price.replace(".00", "")
          );
          var cartPrice = $(".product-template .sezzel-at-checkout h4").attr(
            "data-cart"
          );
          var totalPrice =
            parseInt(cartPrice) + parseInt(variant_price_without_moneyformat);
          if (totalPrice > 100000) {
            $(".product-template .sezzel-at-checkout h4").removeClass("active");
            $(".product-template .sezzel-at-checkout h4.over-1000").addClass(
              "active"
            );
            $(".sezzle-button-text img").attr(
              "src",
              "https://cdn.shopify.com/s/files/1/2494/2652/files/affirm_x44.png?v=1669732943"
            );
            $(".sezzle-button-text img").addClass("affirm-logo");
            $(".sezzle-button-text img").addClass("active");
          } else {
            $(".product-template .sezzel-at-checkout h4").removeClass("active");
            $(".product-template .sezzel-at-checkout h4.under-1000").addClass(
              "active"
            );
            $(".sezzle-button-text img").attr(
              "src",
              "https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg"
            );
            $(".sezzle-button-text img").removeClass("affirm-logo");
            $(".sezzle-button-text img").addClass("active");
          }

          var new_price = parseInt($(this).attr("varient_price"));
          var sezzle_1 = new_price / 4;
          var sezzle_2 = Shopify.formatMoney(sezzle_1);
          $(".product-template span.product_price_main.right-price").text(
            sezzle_2
          );
          $(".product-template .sezzle-payment-amount").text(sezzle_2);

          var pre_order_text = $(this).attr("pre-order-text").trim();

          $(".available-status .stock_text").removeClass("active");
          $(".available-status .stock_text.in-stock").addClass("active");

          if (
            pre_order_text.toLowerCase().includes("pre-order") ||
            pre_order_text.toLowerCase().includes("join waitlist")
          ) {
            var pre_order_text1 = pre_order_text.split("(")[1];
            var pre_order_text2 = pre_order_text1.split(")")[0];
            $(".product-template .hush_product_button")
              .find("button:eq(0) > span")
              .html(pre_order_text2);
            $("#sticky-product-form .product-form__submit > span").html(
              "pre-order"
            );
            // $('#sticky-product-form .product-form__submit').addClass('pre_order_btn');
            $("#sticky-product-form .product-form__submit").removeClass(
              "buy_now_btn"
            );
            $("#sticky-product-form .product-form__submit").removeClass(
              "sold_out"
            );
            $(".product-template .btn_etxt_properties").val(pre_order_text2);
            $(".product-template .btn_etxt_propertie_shipping").val(
              pre_order_text2
            );
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("sold_out");
            // $('.product-template .hush_product_button').find('button:eq(0)').addClass('pre_order_btn');
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("buy_now_btn");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("add_to_cat_btn");
            $(".available-status .stock_text").removeClass("active");
            //$('.available-status .stock_text.out-stock').addClass('active')
          } else if (
            pre_order_text.includes("Buy Now") ||
            pre_order_text.includes("FAST AND FREE")
          ) {
            var pre_order_text1 = pre_order_text.split("(")[1];
            var pre_order_text2 = pre_order_text1.split(")")[0];
            $(".product-template .hush_product_button")
              .find("button:eq(0) > span")
              .html(pre_order_text2);
            $("#sticky-product-form .product-form__submit > span").html(
              "Add to cart"
            );
            $("#sticky-product-form .product-form__submit").addClass(
              "add_to_cat_btn"
            );
            // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
            $("#sticky-product-form .product-form__submit").removeClass(
              "sold_out"
            );
            $(".product-template .btn_etxt_properties").val(pre_order_text2);
            $(".product-template .btn_etxt_propertie_shipping").val("");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("sold_out");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .addClass("buy_now_btn");
            // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("add_to_cat_btn");
          } else if (pre_order_text.includes("sold out")) {
            var pre_order_text1 = pre_order_text.split("(")[1];
            var pre_order_text2 = pre_order_text1.split(")")[0];
            $(".product-template .hush_product_button")
              .find("button:eq(0) > span")
              .html(pre_order_text2);
            $("#sticky-product-form .product-form__submit > span").html(
              "Sold Out"
            );
            $("#sticky-product-form .product-form__submit").addClass(
              "sold_out"
            );
            // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
            $("#sticky-product-form .product-form__submit").removeClass(
              "add_to_cat_btn"
            );
            $(".product-template .btn_etxt_properties").val(pre_order_text2);
            $(".product-template .btn_etxt_propertie_shipping").val("");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .addClass("sold_out");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("buy_now_btn");
            // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("add_to_cat_btn");
            $(".available-status .stock_text").removeClass("active");
            $(".available-status .stock_text.out-stock").addClass("active");
          } else {
            $(".product-template .hush_product_button")
              .find("button:eq(0) > span")
              .html("Buy Now - Fast & Free Shipping");
            $("#sticky-product-form .product-form__submit > span").html(
              "Add to cart"
            );
            $("#sticky-product-form .product-form__submit").addClass(
              "add_to_cat_btn"
            );
            // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
            $("#sticky-product-form .product-form__submit").removeClass(
              "sold_out"
            );
            $(".product-template .btn_etxt_properties").val("Add to cart");
            $(".product-template .btn_etxt_propertie_shipping").val("");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("sold_out");
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .addClass("add_to_cat_btn");
            // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
            $(".product-template .hush_product_button")
              .find("button:eq(0)")
              .removeClass("buy_now_btn");
          }

          var free_trial_text = $(this).attr("free-trial-text");

          if (free_trial_text == "") {
            $(".free-trial-text").hide();
          } else {
            $(".free-trial-text").show();
            $(".free-trial-text span").text(free_trial_text);
          }

          if (display_variants) {
            var queryParams = new URLSearchParams(window.location.search);
            queryParams.set("variant", variant_id);
            history.replaceState(null, null, "?" + queryParams.toString());
          }
        }
      });
    }
    if (
      $(".swatch-element").hasClass("color") ||
      $(".swatch-element").hasClass("2-pack") ||
      $(".swatch-element").hasClass("single")
    ) {
      pdp_image_change();
    }
  }

  function secondAvailability(display_variants) {
    var option0 = $('.swatch-element input[name="option-0"]:checked').val();
    var option1 = $('.swatch-element input[name="option-1"]:checked').val();
    var possibles1 = [];
    var soldout = [];
    if (option0 != "" && option1 != "") {
      if (option0 != "") {
        $("select.all-variants option").each(function () {
          var all_options = $(this).attr("data-name");
          if (all_options.includes(option0)) {
            possibles1.push(all_options);
            if ($(this).attr("data-btntxt") == "jtpl-sold") {
              soldout.push(all_options);
            }
            var variant_image = $(this).attr("variant_image").trim();
            var option1_cls = "." + $(this).attr("option1") + ".color label";
            if (variant_image != "") {
              $(option1_cls).css(
                "background-image",
                "url(" + variant_image + ")"
              );
            }
          }
        });
      }
      if (option1 != "") {
        var optionTriggerFlag = false;
        var exist = 0;
        $('.swatch-element input[name="option-1"]').each(function () {
          var option1_val = $(this).val();
          // alert(option1_val);
          var optionFlag = false;
          var soldoutFlag = false;

          possibles1.forEach(function (item, index) {
            let newItem = item.split(' / ');
            
            if (newItem[1] == option1_val) {
              optionFlag = true;
            }
            if (item.includes(option0) && item.includes(option1)) {
              //optionTriggerFlag =true;
              exist++;
            }
          });
          soldout.forEach(function (item, index) {
            let newItem = item.split(' / ');
            if (newItem[1] == option1_val) {
              soldoutFlag = true;
            }
          });

          if (optionFlag == true) {
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_1");
            $(this).closest(".swatch-element").removeClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("soldout");
            if (soldoutFlag == true) {
              $(this).closest(".swatch-element").addClass("soldout");
            }
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("available_1");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });

        $('.swatch-element input[name="sticky-option-1"]').each(function () {
          var option1_val = $(this).val();
          // alert(option1_val);
          var optionFlag = false;
          var soldoutFlag = false;

          possibles1.forEach(function (item, index) {
            let newItem = item.split(' / ');
            if (newItem[1] == option1_val) {
              optionFlag = true;
            }
            if (item.includes(option0) && item.includes(option1)) {
              //optionTriggerFlag =true;
              exist++;
            }
          });
          soldout.forEach(function (item, index) {
            let newItem = item.split(' / ');
            if (newItem[1] == option1_val) {
              soldoutFlag = true;
            }
          });

          if (optionFlag == true) {
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_1");
            $(this).closest(".swatch-element").removeClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("soldout");
            if (soldoutFlag == true) {
              $(this).closest(".swatch-element").addClass("soldout");
            }
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("available_1");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });
        // alert('o'+exist)
        setTimeout(available_1, 200);

        function available_1() {
          if (exist == 0) {
            $(".available_1:eq(0)").find("input").trigger("click");
          }
        }

        var vari_combination = option0 + " " + "/" + " " + option1;
        var lower_vari_combination = vari_combination.toLowerCase();

        $("select.all-variants option").each(function () {
          var data_name = $(this).attr("data-name").toLowerCase();

          if (data_name == lower_vari_combination) {
            var variant_id = $(this).val();

            var variant_price = Shopify.formatMoney(
              $(this).attr("varient_price")
            );
            var compaire_price = Shopify.formatMoney(
              $(this).attr("compare_price")
            );

            var variant_price_without_moneyformat =
              $(this).attr("varient_price");
            var compaire_price_without_moneyformat =
              $(this).attr("compare_price");

            $("select.all-variants option").removeAttr("selected");
            $(this).val(variant_id);
            $(this).attr("selected", "selected");
            $(".product-template")
              .find("product-form form")
              .find('input[name="id"]')
              .each(function () {
                $(this).val(variant_id);
              });

            if (
              variant_price_without_moneyformat.length != 0 &&
              compaire_price_without_moneyformat.length == 0
            ) {
              $(".product-template .price.price--large").removeClass(
                "price--on-sale"
              );
              $(".product-template .price__regular dd span").html(
                variant_price.replace(".00", "")
              );
            } else if (
              variant_price_without_moneyformat.length != 0 &&
              compaire_price_without_moneyformat.length != 0
            ) {
              $(".product-template .price.price--large").addClass(
                "price--on-sale"
              );
              $(
                ".product-template .price.price--large.price--on-sale dd.price__compare s.price-item--regular"
              ).html(compaire_price.replace(".00", ""));
              $(
                ".product-template .price.price--large.price--on-sale dd span.price-item.price-item--sale"
              ).html(variant_price.replace(".00", ""));
            }
            $(".product-template .sezzel-at-checkout h4").attr(
              "data-price",
              variant_price_without_moneyformat
            );
            $(".product-template span.product_price_main.left-price").html(
              variant_price.replace(".00", "")
            );
            var cartPrice = $(".product-template .sezzel-at-checkout h4").attr(
              "data-cart"
            );
            var totalPrice =
              parseInt(cartPrice) + parseInt(variant_price_without_moneyformat);
            if (totalPrice > 100000) {
              $(".product-template .sezzel-at-checkout h4").removeClass(
                "active"
              );
              $(".product-template .sezzel-at-checkout h4.over-1000").addClass(
                "active"
              );
              $(".sezzle-button-text img").attr(
                "src",
                "https://cdn.shopify.com/s/files/1/2494/2652/files/affirm_x44.png?v=1669732943"
              );
              $(".sezzle-button-text img").addClass("affirm-logo");
              $(".sezzle-button-text img").addClass("active");
            } else {
              $(".product-template .sezzel-at-checkout h4").removeClass(
                "active"
              );
              $(".product-template .sezzel-at-checkout h4.under-1000").addClass(
                "active"
              );
              $(".sezzle-button-text img").attr(
                "src",
                "https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg"
              );
              $(".sezzle-button-text img").removeClass("affirm-logo");
              $(".sezzle-button-text img").addClass("active");
            }
            var new_price = parseInt($(this).attr("varient_price"));
            var sezzle_1 = new_price / 4;
            var sezzle_2 = Shopify.formatMoney(sezzle_1);
            $(".product-template span.product_price_main.right-price").text(
              sezzle_2
            );
            $(".product-template .sezzle-payment-amount").text(sezzle_2);

            $(".available-status .stock_text").removeClass("active");
            $(".available-status .stock_text.in-stock").addClass("active");

            var pre_order_text = $(this).attr("pre-order-text").trim();
            if (pre_order_text.toLowerCase().includes("pre-order")) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "pre-order"
              );
              // $('#sticky-product-form .product-form__submit').addClass('pre_order_btn');
              $("#sticky-product-form .product-form__submit").removeClass(
                "buy_now_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val(
                pre_order_text2
              );
              // $('.product-template .hush_product_button').find('button:eq(0)').addClass('pre_order_btn');
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
              $(".available-status .stock_text").removeClass("active");
              //$('.available-status .stock_text.out-stock').addClass('active')
            } else if (pre_order_text.includes("Buy Now")) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "Add to cart"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "add_to_cat_btn"
              );
              // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("buy_now_btn");
              // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
            } else if (pre_order_text.includes("sold out")) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "Sold Out"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "sold_out"
              );
              // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
              $("#sticky-product-form .product-form__submit").removeClass(
                "add_to_cat_btn"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("sold_out");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
              // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".available-status .stock_text").removeClass("active");
              $(".available-status .stock_text.out-stock").addClass("active");
            } else {
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html("Buy Now - Fast & Free Shipping");
              $("#sticky-product-form .product-form__submit > span").html(
                "Add to cart"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "add_to_cat_btn"
              );
              // $('#sticky-product-form .product-form__submit').removeClass('pre_order_btn');
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val("Add to cart");
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("add_to_cat_btn");
              // $('.product-template .hush_product_button').find('button:eq(0)').removeClass('pre_order_btn');
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
            }
            var free_trial_text = $(this).attr("free-trial-text");

            if (free_trial_text == "") {
              $(".free-trial-text").hide();
            } else {
              $(".free-trial-text").show();
              $(".free-trial-text span").text(free_trial_text);
            }

            if (display_variants) {
              var queryParams = new URLSearchParams(window.location.search);
              queryParams.set("variant", variant_id);
              history.replaceState(null, null, "?" + queryParams.toString());
            }
          }
        });
      }
    }
    pdp_image_change();
  }

  function thirdAvailability(display_variants) {
    var option0 = $('.swatch-element input[name="option-0"]:checked').val();
    var option1 = $('.swatch-element input[name="option-1"]:checked').val();
    var option2 = $('.swatch-element input[name="option-2"]:checked').val();
    var possibles1 = [];
    var possibles2 = [];
    var soldout = [];
    var soldout2 = [];
    if (option0 != "" && option1 != "" && option2 != "") {
      if (option0 != "") {
        $("select.all-variants option").each(function () {
          var all_options = $(this).attr("data-name");

          if (all_options.includes(option0)) {
            possibles1.push(all_options);
            if ($(this).attr("data-btntxt") == "jtpl-sold") {
              soldout.push(all_options);
            }
            var variant_image = $(this).attr("variant_image").trim();
            var option1_cls = "." + $(this).attr("option1") + ".color label";
            if (variant_image != "") {
              $(option1_cls).css(
                "background-image",
                "url(" + variant_image + ")"
              );
            }
          }
        });
      }
      if (option1 != "") {
        var optionTriggerFlag = false;
        $('.swatch-element input[name="sticky-option-1"]').each(function () {
          var option1_val = $(this).val();
          // alert(option1_val);
          var optionFlag = false;
          possibles1.forEach(function (item, index) {
            let newItem = item.split(' / ');
            if (newItem[1] == option1_val) {
              optionFlag = true;
            }
            if (newItem[0] == option0 && newItem[1] == option1) {
              optionTriggerFlag = true;
            }
          });

          if (optionFlag == true) {
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_1");
            $(this).closest(".swatch-element").removeClass("Unavailable_1");
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("available_1");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });
        $('.swatch-element input[name="option-1"]').each(function () {
          var option1_val = $(this).val();
          // alert(option1_val);
          var optionFlag = false;
          possibles1.forEach(function (item, index) {
            let newItem = item.split(' / ');
            if (newItem[1] == option1_val) {
              optionFlag = true;
            }
            if (newItem[0] == option0 && newItem[1] == option1) {
              optionTriggerFlag = true;
            }
          });

          if (optionFlag == true) {
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_1");
            $(this).closest(".swatch-element").removeClass("Unavailable_1");
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_1");
            $(this).closest(".swatch-element").removeClass("available_1");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });
        setTimeout(available_1, 200);

        function available_1() {
          if (optionTriggerFlag == false) {
            $(".available_1:eq(0)").find("input").trigger("click");
          }
        }

        possibles1.forEach(function (item, index) {
          let newItem = item.split(' / ');
          if (newItem[0] == option0 && newItem[1] == option1) {
            possibles2.push(item);
          }
        });

        soldout.forEach(function (item, index) {
          let newItem = item.split(' / ');
          if (newItem[0] == option0 && newItem[1] == option1) {
            soldout2.push(item);
          }
        });
      }
      if (option2 != "") {
        var exist = 0;
        $('.swatch-element input[name="sticky-option-2"]').each(function () {
          var option2_val = $(this).val();
          var optionFlag = false;
          var soldoutFlag = false;
          var optionTriggerFlag = false;
          // alert(option2_val);
          possibles2.forEach(function (item, index) {
            var newItem = item.split(" / ");
            if (newItem[2] == option2_val) {
              optionFlag = true;
            }
            if (
              newItem[0] == option0 &&
              newItem[1] == option1 &&
              newItem[2] == option2
            ) {
              exist++;
            }
          });
          soldout.forEach(function (item, index) {
            var newItem = item.split(" / ");
            if (newItem[2] == option2_val) {
              soldoutFlag = true;
            }
          });
          if (optionFlag == true) {
            console.log(optionFlag);
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_2");
            $(this).closest(".swatch-element").removeClass("Unavailable_2");
            $(this).closest(".swatch-element").removeClass("soldout");
            if (soldoutFlag == true) {
              $(this).closest(".swatch-element").addClass("soldout");
            }
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_2");
            $(this).closest(".swatch-element").removeClass("available_2");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });
        $('.swatch-element input[name="option-2"]').each(function () {
          var option2_val = $(this).val();
          var optionFlag = false;
          var soldoutFlag = false;
          var optionTriggerFlag = false;
          // alert(option2_val);
          possibles2.forEach(function (item, index) {
            var newItem = item.split(" / ");
            if (newItem[2] == option2_val) {
              optionFlag = true;
            }
            if (
              newItem[0] == option0 &&
              newItem[1] == option1 &&
              newItem[2] == option2
            ) {
              exist++;
            }
          });
          soldout2.forEach(function (item, index) {
            var newItem = item.split(" / ");
            if (newItem[2] == option2_val) {
              soldoutFlag = true;
            }
          });
          if (optionFlag == true) {
            $(this).closest(".swatch-element").addClass("available");
            $(this).closest(".swatch-element").addClass("available_2");
            $(this).closest(".swatch-element").removeClass("Unavailable_2");
            $(this).closest(".swatch-element").removeClass("soldout");
            if (soldoutFlag == true) {
              $(this).closest(".swatch-element").addClass("soldout");
            }
          } else {
            $(this).closest(".swatch-element").addClass("Unavailable_2");
            $(this).closest(".swatch-element").removeClass("available_2");
            $(this).closest(".swatch-element").removeClass("available");
          }
        });
        setTimeout(available_2, 300);

        function available_2() {
          if (exist == 0) {
            $(".available_2:eq(0)").find("input").trigger("click");
          }
        }
        $("select.all-variants option").each(function () {
          var data_name = $(this).attr("data-name");
          var newData_name = data_name.split(" / ");
          if (
            newData_name[0] == option0 &&
            newData_name[1] == option1 &&
            newData_name[2] == option2
          ) {
            var variant_id = $(this).val();
            var variant_price = Shopify.formatMoney(
              $(this).attr("varient_price")
            );
            var compaire_price = Shopify.formatMoney(
              $(this).attr("compare_price")
            );
            var queryParams = new URLSearchParams(window.location.search);
            $("select.all-variants option").removeAttr("selected");
            $("select.all-variants").val(variant_id);
            $(this).attr("selected", "selected");
            $(".product-template")
              .find("product-form form")
              .find('input[name="id"]')
              .each(function () {
                $(this).val(variant_id);
              });

            var variant_price_without_moneyformat =
              $(this).attr("varient_price");
            var compaire_price_without_moneyformat =
              $(this).attr("compare_price");

            if (
              variant_price_without_moneyformat.length != 0 &&
              compaire_price_without_moneyformat.length == 0
            ) {
              $(".product-template .price.price--large").removeClass(
                "price--on-sale"
              );
              $(".product-template .price__regular dd span").html(
                variant_price.replace(".00", "")
              );
            } else if (
              variant_price_without_moneyformat.length != 0 &&
              compaire_price_without_moneyformat.length != 0
            ) {
              $(".product-template .price.price--large").addClass(
                "price--on-sale"
              );
              $(
                ".product-template .price.price--large.price--on-sale dd.price__compare s.price-item--regular"
              ).html(compaire_price.replace(".00", ""));
              $(".product-template")
                .find(".price.price--large.price--on-sale")
                .find("dd")
                .find("span.price-item.price-item--sale")
                .html(variant_price.replace(".00", ""));
            }

            $(".product-template .sezzel-at-checkout h4").attr(
              "data-price",
              variant_price_without_moneyformat
            );
            $(".product-template span.product_price_main.left-price").html(
              variant_price.replace(".00", "")
            );
            var cartPrice = $(".product-template .sezzel-at-checkout h4").attr(
              "data-cart"
            );
            var totalPrice =
              parseInt(cartPrice) + parseInt(variant_price_without_moneyformat);
            if (totalPrice > 100000) {
              $(".product-template .sezzel-at-checkout h4").removeClass(
                "active"
              );
              $(".product-template .sezzel-at-checkout h4.over-1000").addClass(
                "active"
              );
              $(".sezzle-button-text img").attr(
                "src",
                "https://cdn.shopify.com/s/files/1/2494/2652/files/affirm_x44.png?v=1669732943"
              );
              $(".sezzle-button-text img").addClass("affirm-logo");
              $(".sezzle-button-text img").addClass("active");
            } else {
              $(".product-template .sezzel-at-checkout h4").removeClass(
                "active"
              );
              $(".product-template .sezzel-at-checkout h4.under-1000").addClass(
                "active"
              );
              $(".sezzle-button-text img").attr(
                "src",
                "https://media.sezzle.com/branding/2.0/Sezzle_Logo_FullColor.svg"
              );
              $(".sezzle-button-text img").removeClass("affirm-logo");
              $(".sezzle-button-text img").addClass("active");
            }
            var new_price = parseInt($(this).attr("varient_price"));
            var sezzle_1 = new_price / 4;
            var sezzle_2 = Shopify.formatMoney(sezzle_1);
            $(".product-template span.product_price_main.right-price").text(
              sezzle_2
            );
            $(".product-template .sezzle-payment-amount").text(sezzle_2);

            $(".available-status .stock_text").removeClass("active");
            $(".available-status .stock_text.in-stock").addClass("active");
            var pre_order_text = $(this).attr("pre-order-text").trim();
            console.log(pre_order_text);
            if (
              pre_order_text.toLowerCase().includes("pre-order") ||
              pre_order_text.toLowerCase().includes("join waitlist")
            ) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "pre-order"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "pre_order_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "buy_now_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val(
                pre_order_text2
              );
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("pre_order_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
              $(".available-status .stock_text").removeClass("active");
              //$('.available-status .stock_text.out-stock').addClass('active')
            } else if (pre_order_text.includes("Buy Now")) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "Add to cart"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "add_to_cat_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "pre_order_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("buy_now_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("pre_order_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
            } else if (pre_order_text.includes("sold out")) {
              var pre_order_text1 = pre_order_text.split("(")[1];
              var pre_order_text2 = pre_order_text1.split(")")[0];
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html(pre_order_text2);
              $("#sticky-product-form .product-form__submit > span").html(
                "Sold Out"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "sold_out"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "pre_order_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "add_to_cat_btn"
              );
              $(".product-template .btn_etxt_properties").val(pre_order_text2);
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("sold_out");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("pre_order_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("add_to_cat_btn");
              $(".available-status .stock_text").removeClass("active");
              $(".available-status .stock_text.out-stock").addClass("active");
            } else {
              $(".product-template .hush_product_button")
                .find("button:eq(0) > span")
                .html("Buy Now - Fast & Free Shipping");
              $("#sticky-product-form .product-form__submit > span").html(
                "Add to cart"
              );
              $("#sticky-product-form .product-form__submit").addClass(
                "add_to_cat_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "pre_order_btn"
              );
              $("#sticky-product-form .product-form__submit").removeClass(
                "sold_out"
              );
              $(".product-template .btn_etxt_properties").val("Add to cart");
              $(".product-template .btn_etxt_propertie_shipping").val("");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .addClass("add_to_cat_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("buy_now_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("pre_order_btn");
              $(".product-template .hush_product_button")
                .find("button:eq(0)")
                .removeClass("sold_out");
            }

            var free_trial_text = $(this).attr("free-trial-text");

            if (free_trial_text == "") {
              $(".free-trial-text").hide();
            } else {
              $(".free-trial-text").show();
              $(".free-trial-text span").text(free_trial_text);
            }

            if (display_variants) {
              var queryParams = new URLSearchParams(window.location.search);
              queryParams.set("variant", variant_id);
              history.replaceState(null, null, "?" + queryParams.toString());
            }
          }
        });
      }
    }
    pdp_image_change();
  }

  function pdp_image_change() {
    var clear = setInterval(check_thumbnail_slider, 100);

    function check_thumbnail_slider() {
      var option0 = $('.swatch-element input[name="option-0"]:checked').val();
      var option1 = $('.swatch-element input[name="option-1"]:checked').val();
      var option2 = $('.swatch-element input[name="option-2"]:checked').val();
      var vari_combination = "";
      if (option0 != undefined) {
        vari_combination = option0;
      }
      if (option1 != undefined) {
        vari_combination = vari_combination + " " + "/" + " " + option1;
      }
      if (option2 != undefined) {
        vari_combination =
          vari_combination +
          " " +
          "/" +
          " " +
          option1 +
          " " +
          "/" +
          " " +
          option2;
      }

      var newoption0 = vari_combination.toLowerCase();
      var swatch_element = $(".product-template .swatch .swatch-element:eq(0)");
      var main_slider = $(".main_product_slider .product__media-item");
      var thumbnails_slider = $(".thumbnails_slider .product__media-item");
      var matched_images = thumbnails_slider.length;
      var side_image;
      thumbnails_slider.each(function () {
        $(this).removeClass("hide");
        var each_alt = $(this).attr("alt").toLowerCase();
        if(each_alt.includes('/')){
          let noSpacesAltText = each_alt.replace(/(\S)\s+(\S)/g, '$1$2').replace('+ ', '');
          let cleanedAltText = noSpacesAltText.replace(/\s*\/\s*/g, ' ');
          let altLength = cleanedAltText.trim().split(/\s+/).length;
          
          let first_option = option0 ? option0.replace(/(\S)\s+(\S)/g, '$1$2').replace('+ ', '').toLowerCase() : null;
          let second_option = option1 ? option1.replace(/(\S)\s+(\S)/g, '$1$2').toLowerCase() : null;
          let third_option = option2 ? option2.replace(/(\S)\s+(\S)/g, '$1$2').toLowerCase() : null;
          if(altLength < 3){
            if(cleanedAltText.includes(first_option) && cleanedAltText.includes(second_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else if(cleanedAltText.includes(first_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else if(cleanedAltText.includes(second_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            }
            else {
              $(this).addClass('hide');
            }
          }
          else if(altLength < 4){
            console.log('checking', cleanedAltText, first_option, second_option, third_option);
            if(cleanedAltText.includes(first_option) && cleanedAltText.includes(second_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else {
              $(this).addClass('hide');
            }
          }
        } else if (newoption0.indexOf(each_alt) < 0) {
          $(this).addClass("hide");
          matched_images--;
        } else if (side_image == null) {
          side_image = $(this).find("img").attr("src");
        }
      });
      $("#sticky-product-form .product_media-container img").attr(
        "src",
        side_image
      );
      if (main_slider.length > 0 && matched_images > 0) {
        clearInterval(clear);
        if ($(window).width() < 750) {
          $(".main_product_slider").slick("unslick");
        }
        var filter_status = false;
        main_slider.each(function () {
          $(this).removeClass("hide");
          var each_alt = $(this).attr("alt").toLowerCase();
        if(each_alt.includes('/')){
          
        let noSpacesAltText = each_alt.replace(/(\S)\s+(\S)/g, '$1$2').replace('+ ', '');
        let cleanedAltText = noSpacesAltText.replace(/\s*\/\s*/g, ' ');
        let altLength = cleanedAltText.trim().split(/\s+/).length;
         let first_option = option0 ? option0.replace(/(\S)\s+(\S)/g, '$1$2').replace('+ ', '').toLowerCase() : null;
    let second_option = option1 ? option1.replace(/(\S)\s+(\S)/g, '$1$2').toLowerCase() : null;
    let third_option = option2 ? option2.replace(/(\S)\s+(\S)/g, '$1$2').toLowerCase() : null;
          if(altLength < 3){
            if(cleanedAltText.includes(first_option) && cleanedAltText.includes(second_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else if(cleanedAltText.includes(first_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else if(cleanedAltText.includes(second_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            }
            else {
              $(this).addClass('hide');
            }
          }
          else if(altLength < 4){
            console.log('h', cleanedAltText, 'z', first_option);
            if(cleanedAltText.includes(first_option) && cleanedAltText.includes(second_option) && cleanedAltText.includes(third_option)){
              $(this).removeClass('hide');
              matched_images--;
            } else {
              $(this).addClass('hide');
            }
          }
        } else if (newoption0.indexOf(each_alt) < 0) {
            $(this).addClass("hide");
          }
        });
        if ($(window).width() < 750) {
          $(".main_product_slider").slick({
            slidesToShow: 1,
            dots: true,
            slide: ".carousel--item:not(.hide)",
            arrows: false,
            adaptiveHeight: true,
          });
        }
      } else {
        main_slider.removeClass("hide");
        thumbnails_slider.removeClass("hide");
      }
    }
  }

  var sizesArray = [
    {
      size: "TWIN 60x80",
      weights: ["80-150", "151-299", "300-309", "310-349", "350+"],
    },
    { size: "QUEEN 80x87", weights: ["80-200", "201-250", "251+"] },
    { size: "KING 90x90", weights: ["80-300", "301-350", "351+"] },
    { size: "KING 94x96", weights: ["80-300", "301-350", "351+"] },
  ];

  var weightsArray = [
    {
      size: "TWIN 60x80",
      weight: "15lb",
      bodyWeights: [8, 9, 10, 11, 12, 13, 14, 15],
    },
    {
      size: "TWIN 60x80",
      weight: "20lb",
      bodyWeights: [
        16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33,
        34, 35, 36, 37, 38, 39, 40,
      ],
    },
    {
      size: "QUEEN 80x87",
      weight: "20lb",
      bodyWeights: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
    },
    { size: "QUEEN 80x87", weight: "25lb", bodyWeights: [21, 22, 23, 24, 25] },
    {
      size: "QUEEN 80x87",
      weight: "30lb",
      bodyWeights: [26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
    },
    {
      size: "KING 90x90",
      weight: "30lb",
      bodyWeights: [
        8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30,
      ],
    },
    {
      size: "KING 90x90",
      weight: "35lb",
      bodyWeights: [31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
    },
    {
      size: "KING 94x96",
      weight: "30lb",
      bodyWeights: [
        8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
        26, 27, 28, 29, 30,
      ],
    },
    {
      size: "KING 94x96",
      weight: "35lb",
      bodyWeights: [31, 32, 33, 34, 35, 36, 37, 38, 39, 40],
    },
  ];
  window["alternate_pdp_quiz_feature"] = function () {
    var alternate_pdp_quiz_var = setInterval(alternate_pad_quiz_fun, 3000);
    var product_handle = "";
    function alternate_pad_quiz_fun() {
      var pdp_length = $("#alternate_product").length;
      product_handle = $(".quiz_product").attr("id");
      if (
        pdp_length == 1 &&
        typeof product_handle !== "undefined" &&
        product_handle != "hush-sheets"
      ) {
        clearInterval(alternate_pdp_quiz_var);
        add_alternate_pdp_quiz_class();
      }
    }
    function add_alternate_pdp_quiz_class() {
      $("body").addClass("alternate_pdp_quiz_feature");
      $(".alternate_pdp_quiz_feature #alternate_product .swatch .header").each(
        function () {
          var case_text = $(this).text().toLowerCase();
          var get_option = case_text.split(" ")[0];
          if (case_text.includes("size") || case_text.includes("weight")) {
            $(this)
              .closest(".swatch")
              .addClass(get_option + "_option");
          }
        }
      );
      addTakeAQuizLink();
      addQuizPopup();
      checkActiveQues();
      addWeightChange();
      changeAddToCartBtnTxt();
      onFetchEnd_2809();
    }
  };
  function addTakeAQuizLink() {
    var toolTipHtml = '<span class="vwo_qLink">(Répondez à un quiz)</span>';
    if (!$(".vwo_qLink").length) {
      $(".swatch.size_option > .header").append(toolTipHtml);
    }
  }
  function addQuizPopup() {
    var qHtml =
      '<div class="vwo_modal"><span class="vwo_overlay"></span><div class="modalContent">';
    qHtml += '<span class="popClose">×</span>';
    qHtml += '<div class="quesStepper" data-current-ques="1">';
    qHtml +=
      '<div class="qBlock qBedSize" data-ques="1"><h3>Quelle est la taille de votre lit ?</h3><div class="qAns aBedSize"></div></div>';
    qHtml +=
      '<div class="qBlock qWeight" data-ques="2"><h3>Quels sont vos poids combinés (ou votre poids si vous dormez seul) ?</h3><div class="qAns aWeight"></div></div>';
    qHtml +=
      '<div class="qBlock qResult" data-ques="3"><div class="qAns aResult"></div><div class="resText">You will get your best sleep with this Hush Blanket.</div><div class="btnsArea"><button onclick="gotoQues(1)" class="recalcBtn btn btn--fill btn--color btn--regular"><span class="v_lArrow">←</span>Go Back</button><button onclick="triggerCartClick()" class="v_cartBtn btn btn--fill btn--color btn--regular"><span class="v_btnTxt">Ajouter à la liste Panier</span> <svg class="cartLoader" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"> <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"> <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform> </path> </svg></button></div></div>';
    qHtml += "</div>";
    qHtml += "</div></div>";
    if (!$(".vwo_quizPopup").length) {
      $("body").prepend(qHtml);
      addBedSizes();
      addSizeClick();
    }
  }
  function addBedSizes() {
    $(".size_option .swatch-element").each(function () {
      var text = $(this).find("input[type=radio]").val().trim();
      var aHtml = "";
      if (!$(this).hasClass("not-avilable")) {
        aHtml = '<a href="javascript:void(0);">' + text + "</a>";
      } else {
        aHtml =
          '<a href="javascript:void(0);" class="disabled" disabled="">' +
          text +
          "</a>";
      }
      $(aHtml).appendTo(".aBedSize");
    });
  }
  function addSizeClick() {
    $(document).on("click", ".aBedSize a", function () {
      var prodName = formatProdName($(".product__title").text().trim());
      $(".aBedSize a").removeClass("active");
      $(this).addClass("active");
      var size = $(this).text();

      var selectedWeight = "";
      if (size.indexOf("TEEN") > -1) {
        $(".qResult").attr("data-size", size).attr("data-weight", "12lb");
        gotoQues(3);
        $(".aResult").html(
          "<p>YOU + a <strong>12lb</strong> " +
            prodName +
            " are a match made in heaven!</p>"
        );
        selectedWeight = "12lb";
      } else if (size.indexOf("KID") > -1) {
        $(".qResult").attr("data-size", size).attr("data-weight", "5lb");
        gotoQues(3);
        $(".aResult").html(
          "<p>YOU + a <strong>5lb</strong> " +
            prodName +
            " are a match made in heaven!</p>"
        );
        selectedWeight = "5lb";
      } else {
        $(".qWeight").attr("data-size", size);
        gotoQues(2);
        generateWeights(size);
      }
      triggerSizeSelection(size);
      setTimeout(function () {
        if (selectedWeight) {
          triggerWeightSelection(selectedWeight);
        }
      }, 1000);
    });
  }
  function generateWeights(size) {
    var sel =
      '<div class="selectedSize"><p>Selected Size: ' +
      size +
      ' <a href="javascript:void(0);" onclick="gotoQues(1)" class="change_size">Change here</a></p><select class="sizeOpts"><option value="null">Sélectionner le poids</option>';
    for (var i = 0; i < sizesArray.length; i++) {
      var sizeThis = sizesArray[i].size;
      if (sizeThis.toLowerCase() == size.toLowerCase()) {
        var weights = sizesArray[i].weights;
        for (var j = 0; j < weights.length; j++) {
          var weight = weights[j];
          sel +=
            weight.indexOf("-") > -1
              ? '<option value="' + weight + '">' + weight + " LB</option>"
              : '<option value="' +
                weight +
                '">' +
                weight.replace("+", "") +
                "LB+</option>";
        }
      }
    }
    sel += "</select></div>";
    $(".aWeight").html(sel);
  }
  function addWeightChange() {
    $(document).on("change", ".sizeOpts", function () {
      var prodName = formatProdName($(".product__title").text().trim());
      var minweight =
        $(this).val().indexOf("-") > -1
          ? parseInt($(this).val().split("-").shift())
          : parseInt($(this).val().split("+").shift());
      var maxWeight =
        $(this).val().indexOf("-") > -1
          ? parseInt($(this).val().split("-").pop())
          : 400;
      var finalMinWeight = (10 / 100) * minweight;
      var finalMaxWeight = (10 / 100) * maxWeight;
      var selectedSize = $(".qWeight").attr("data-size");
      for (var i = 0; i < weightsArray.length; i++) {
        var sizeArr = weightsArray[i].size;
        if (selectedSize.toLowerCase() == sizeArr.toLowerCase()) {
          var bodyWeights = weightsArray[i].bodyWeights;
          var selectedWeight = "";
          for (var j = 0; j < bodyWeights.length; j++) {
            if (bodyWeights[i] <= finalMaxWeight) {
              $(".qResult")
                .attr("data-size", selectedSize)
                .attr("data-weight", weightsArray[i].weight);
              gotoQues(3);
              $(".aResult").html(
                "<p>YOU + a <strong>" +
                  weightsArray[i].weight +
                  "</strong> " +
                  prodName +
                  " are a match made in heaven!</p>"
              );
              selectedWeight = weightsArray[i].weight;
            }
          }
          if (selectedWeight) {
            triggerWeightSelection(selectedWeight);
          }
        }
      }
    });
  }
  function triggerVariants(cb) {
    var size = $(".qResult").attr("data-size");
    var weight = $(".qResult").attr("data-weight");
    $(
      ".size_option .swatch-element:not(.not-avilable) label:contains(" +
        size +
        ")"
    ).click();
    setTimeout(function () {
      var availableWeight = $(
        ".weight_option .swatch-element:not(.not-avilable):visible label:contains(" +
          weight.toUpperCase() +
          ")"
      ).length
        ? $(
            ".weight_option .swatch-element:not(.not-avilable):visible label:contains(" +
              weight.toUpperCase() +
              ")"
          )
        : $(
            ".weight_option .swatch-element:not(.not-avilable):visible label:contains(" +
              weight +
              ")"
          );
      if (availableWeight.length) {
        availableWeight.click();
        closeQPop();
        cb();
      } else {
        $("body").removeClass("loadingPop");
        alert("Blanket weight not available for selection for now.");
      }
    }, 1000);
  }
  function triggerSizeSelection(size) {
    //$('.size_option .swatch-element:not(.not-avilable) label:contains('+size+')').trigger("click");
    $(".size_option .swatch-element:visible label:contains(" + size + ")")
      .prev("input")[0]
      .click();
  }
  function triggerWeightSelection(weight) {
    //var availableWeight = $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')').length ? $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight.toUpperCase()+')') : $('.weight_option .swatch-element:not(.not-avilable):visible label:contains('+weight+')');
    var availableWeight = $(
      ".weight_option .swatch-element:visible label:contains(" +
        weight.toUpperCase() +
        ")"
    ).length
      ? $(
          ".weight_option .swatch-element:visible label:contains(" +
            weight.toUpperCase() +
            ")"
        )
      : $(
          ".weight_option .swatch-element:visible label:contains(" +
            weight +
            ")"
        );
    if (availableWeight.length) {
      availableWeight[0].click();
      changeAddToCartBtnTxt();
    }
    /*else {
        alert('Blanket weight not available for selection for now.');
        }*/
  }
  function gotoQues(ques) {
    $(".quesStepper").attr("data-current-ques", ques);
    checkActiveQues();
  }
  function openQPop() {
    if ($(".quesStepper").attr("data-current-ques") == "3") {
      resetQuiz();
    }
    $("body").addClass("popupOpened");
    $(".aBedSize").html("");
    addBedSizes();
  }
  function resetQuiz() {
    $(".quesStepper").attr("data-current-ques", "1");
    $(".qResult").removeAttr("data-weight").removeAttr("data-size");
    $(".qWeight").removeAttr("data-size");
    checkActiveQues();
  }
  function closeQPop() {
    $("body").addClass("closingPop");
    setTimeout(function () {
      $("body").removeClass("closingPop popupOpened");
    }, 350);
  }
  function checkActiveQues() {
    var currStep = $(".quesStepper").attr("data-current-ques");
    $(".qBlock").hide();
    $(".qBlock[data-ques=" + currStep + "]").fadeIn();
  }
  function triggerCartClick() {
    $("body").addClass("loadingPop");
    triggerVariants(function () {
      setTimeout(function () {
        var findBtnVisible = setInterval(function () {
          if ($(".hush_product_button .product-form__submit:visible").length) {
            $(".hush_product_button .product-form__submit:visible").click();
            $("body").removeClass("loadingPop");
            clearInterval(findBtnVisible);
          }
        }, 100);
      }, 500);
    });
  }
  function changeAddToCartBtnTxt() {
    setTimeout(function () {
      var currBtnTxt = $(
        "product-form .hush_product_button .product-form__submit:visible"
      )
        .text()
        .trim();
      var currbtnBg = $(
        "product-form .hush_product_button .product-form__submit:visible"
      ).css("background-color");
      $(".v_cartBtn").css("background-color", currbtnBg);
      $(".v_btnTxt").text(currBtnTxt);
    }, 500);
  }
  function formatProdName(prodName) {
    if (prodName.indexOf("Hush Classic") > -1) {
      prodName = "Hush Classic Blanket";
    } else if (prodName.indexOf("Hush Iced") > -1) {
      prodName = "Hush Iced Blanket";
    } else if (prodName.indexOf("2-in-1") > -1) {
      prodName = "Hush 2-in-1 Blanket";
    } else if (prodName.indexOf("Hush Kids") > -1) {
      prodName = "Hush Kids Blanket";
    }
    return prodName;
  }
  function onFetchEnd_2809() {
    var _oldFetch = fetch;
    window.fetch = function () {
      var fetchStart = new Event("fetchStart", {
        view: document,
        bubbles: true,
        cancelable: false,
      });
      var fetchEnd = new Event("fetchEnd", {
        view: document,
        bubbles: true,
        cancelable: false,
      });
      var fetchCall = _oldFetch.apply(this, arguments);
      document.dispatchEvent(fetchStart);
      fetchCall
        .then(function () {
          document.dispatchEvent(fetchEnd);
        })
        .catch(function () {
          document.dispatchEvent(fetchEnd);
        });
      return fetchCall;
    };
    document.addEventListener("fetchEnd", function () {
      changeAddToCartBtnTxt();
    });
  }

  function formatProdName(prodName) {
    if (prodName.indexOf("Hush Classic") > -1) {
      prodName = "Hush Classic Blanket";
    } else if (prodName.indexOf("Hush Iced") > -1) {
      prodName = "Hush Iced Blanket";
    } else if (prodName.indexOf("2-in-1") > -1) {
      prodName = "Hush 2-in-1 Blanket";
    } else if (prodName.indexOf("Hush Kids") > -1) {
      prodName = "Hush Kids Blanket";
    }
    return prodName;
  }

  window.alternate_pdp_quiz_feature();

  $(document).on("click", ".vwo_qLink", function () {
    openQPop();
  });
  $(document).on("click", ".popClose", function () {
    closeQPop();
  });
  $(document).on("click", ".recalcBtn", function (e) {
    gotoQues(1);
  });
  $(document).on("click", ".change_size", function (e) {
    gotoQues(1);
  });
  $(document).on("click", ".v_cartBtn", function (e) {
    triggerCartClick();
  });
});
